export const productTypeSelect = {
	label: "Type de produit",
	placeholder: "Sélectionner le type",
	loading: "Chargement...",
};
